export default __webpack_public_path__ + "static/media/a037-driverLicenseNumber-06.8bc6ccbd.png";